<template>
  <div class="enrolling-student-verify">
    <el-button class="grid-menu-item" @click="handleMenuClick">
      <i class="iconfont icon-click"></i><span class="text-span">{{menuName}}</span>
    </el-button>
    <DataGridDialog v-if="menuConfig.isRenderPopup"
                    :visible.sync="menuConfig.isShowPopup"
                    :decorator="menuConfig.decorator"
                    v-bind="{
                      title: menuName,
                      width: '1000px',
                      center: true
                    }">
      <template slot-scope="scope">
        <div>
          <DataGridPopover component-path="pages/workspace/manager/enrolling/student/index"
                           :visible="menuConfig.isShowPopup"
                           v-bind="$attrs"
                           @reloadGridData="reloadGridData"
                           @hidePopup="hidePopup()"
                           @hidePopupAndRefresh="hidePopupAndRefresh()"
          ></DataGridPopover>
        </div>
      </template>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../components/elements/grid/DataGridDialog'
import DataGridPopover from '../../../../../../../components/elements/grid/DataGridPopover'
export default {
  name: 'EnrollingStudentVerify',
  components: {DataGridDialog, DataGridPopover},
  props: {
    menuName: String
  },
  data () {
    return {
      menuConfig: {
        isRenderPopup: false,
        isShowPopup: false,
        decorator: false
      }
    }
  },
  methods: {
    handleMenuClick () {
      this.menuConfig.isRenderPopup = true
      this.$nextTick(() => {
        this.menuConfig.isShowPopup = true
      })
    },
    reloadGridData () {
      this.$emit('reloadGridData')
    },
    // 关闭弹出窗口
    hidePopup () {
      this.menuConfig.isShowPopup = false
    },
    // 关闭弹窗并且刷新
    hidePopupAndRefresh () {
      this.menuConfig.isShowPopup = false
      this.reloadGridData()
    }
  }
}
</script>
